function getLocalizedValue(enValue, koValue) {
  const preferredLang = localStorage.getItem('preferredLang') || 'en';
  return preferredLang === 'ko' ? koValue : enValue;
}

export default getLocalizedValue;